import React, { Component } from "react";
import {
  Form as FormInicial,
  message,
  Spin,
  Row,
  Col,
  Select,
  Collapse,
  Tag,
  Checkbox,
  Form as FormInitial
} from "antd";
import { PlusOutlined, DeleteOutlined, FilePdfOutlined, ExperimentOutlined } from "@ant-design/icons";
import { Form, FormItem, InputItem, InputNumberItem, ButtonItem, SwitchItem, ErrorItem, SelectItem, ModalItem } from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { OPCIONES_REDONDEO, OPCIONES_TRIESTADO, OPCIONES_BASE_RECALCULO, normalizarAtajosPorcentaje } from "../../../../Utils/reglasPrecio";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import configuracionListasDePreciosPdf from "../../../../Pdf/configuracionListasDePreciosPdf";
import simulacionListasDePreciosPdf from "../../../../Pdf/simulacionListasDePreciosPdf";
import axios from "axios";
import { connect } from "react-redux";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

// Una lista dada de baja conserva su renglon en el arreglo (con estado 0) para
// no regenerar su _id: todos los Insumo.precios[].precioId apuntan a el.
const listaActiva = (lista) => Number(lista?.estado) !== 0;

class InsumosConfiguracion extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    modalPdf: false,
    incluirReglasPorCliente: false,
    generandoPdf: false,
    generandoSimulacion: false,
  }

  componentDidMount() {
    this.consultarConfiguracion()
  }

  descargarPdfConfiguracion() {
    this.setState({ generandoPdf: true })
    axios
      .post(
        "reglasPrecio/datosPdfConfiguracionPrecios",
        {
          empresaId: this.props.empresaId,
          incluirReglasPorCliente: this.state.incluirReglasPorCliente,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ generandoPdf: false })
        if (res.data.success === 2) {
          this.setState({ modalPdf: false })
          pdfMake
            .createPdf(configuracionListasDePreciosPdf(res.data))
            .download("Configuracion_Listas_De_Precios.pdf")
        } else {
          message.error(res.data.message || "No se pudo generar el PDF")
        }
      })
      .catch(() => {
        this.setState({ generandoPdf: false })
        message.error("Hubo un error y no se genero el PDF")
      });
  }

  descargarPdfSimulacion() {
    this.setState({ generandoSimulacion: true })
    axios
      .post(
        "reglasPrecio/datosPdfSimulacionPrecios",
        // El backend toma una muestra al azar de este tamano; no recorre el catalogo.
        { empresaId: this.props.empresaId, limite: 20 },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ generandoSimulacion: false })
        if (res.data.success === 2) {
          pdfMake
            .createPdf(simulacionListasDePreciosPdf(res.data))
            .download("Simulacion_Listas_De_Precios.pdf")
        } else {
          message.error(res.data.message || "No se pudo generar la simulacion")
        }
      })
      .catch(() => {
        this.setState({ generandoSimulacion: false })
        message.error("Hubo un error y no se genero la simulacion")
      });
  }
  onFinish(values) {
    // Se cuentan solo las listas activas: las dadas de baja siguen viajando en
    // el arreglo con estado 0 para conservar su _id.
    const preciosActivos = (values.precios || []).filter(listaActiva);
    if (preciosActivos.length === 0)
      return message.warning("Es necesario por lo menos un precio");

    const rangoInvalido = preciosActivos.find(
      (lista) =>
        (lista?.margenMinimo || lista?.margenMinimo === 0) &&
        (lista?.margenMaximo || lista?.margenMaximo === 0) &&
        Number(lista.margenMinimo) > Number(lista.margenMaximo)
    );
    if (rangoInvalido)
      return message.warning(
        `En "${rangoInvalido.nombre || "una lista"}" el margen minimo no puede ser mayor al maximo`
      );

    const descuentoInvalido = preciosActivos.find(
      (lista) =>
        (lista?.descuentoMinimo || lista?.descuentoMinimo === 0) &&
        (lista?.descuentoMaximo || lista?.descuentoMaximo === 0) &&
        Number(lista.descuentoMinimo) > Number(lista.descuentoMaximo)
    );
    if (descuentoInvalido)
      return message.warning(
        `En "${descuentoInvalido.nombre || "una lista"}" el descuento minimo no puede ser mayor al maximo`
      );

    // Ojo: antd manda null al limpiar un InputNumber y Number(null) es 0, asi que
    // el renglon vacio se valida contra null/""/undefined, no con isFinite.
    const atajos = (values.atajosPorcentaje || []).map((atajo) => atajo?.porcentaje);
    if (
      atajos.some(
        (porcentaje) =>
          porcentaje === null ||
          porcentaje === undefined ||
          porcentaje === "" ||
          isNaN(Number(porcentaje))
      )
    )
      return message.warning("Hay un atajo de la calculadora sin porcentaje");
    const numeros = atajos.map(Number);
    if (new Set(numeros).size !== numeros.length)
      return message.warning("Hay atajos de la calculadora repetidos");

    this.setState({ loading: true })
    axios
      .post(
        "empresas/editarConfiguracionInsumos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({ loading: true })
    await axios
      .post(
        "empresas/selectConfiguracionInsumos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.formRef.current.setFieldsValue({
            calcularPreciosAutomaticamente:
              res.data.configuracion?.calcularPreciosAutomaticamente,
            noBajarPreciosAutomaticamente:
              res.data.configuracion?.noBajarPreciosAutomaticamente,
            calcularPreciosSobre:
              res.data.configuracion?.calcularPreciosSobre,
            valuacionInventarios: res.data.configuracion?.valuacionInventarios,
            precios: res.data.configuracion?.precios,
            venderSinInventario: res.data.configuracion?.venderSinInventario,
            noVenderAbajoCosto: res.data.configuracion?.noVenderAbajoCosto,
            marbetes: res.data.configuracion?.marbetes,
            // Si la empresa no configuro atajos se precargan los de por defecto:
            // son los que realmente estan en efecto en la calculadora, y asi la
            // pantalla no miente mostrando una lista vacia.
            atajosPorcentaje: normalizarAtajosPorcentaje(
              res.data.configuracion?.atajosPorcentaje
            ).map((porcentaje) => ({ porcentaje })),
            codBarObligatorio: res.data.configuracion.codBarObligatorio,
            claveIrrepetible: res.data.configuracion.claveIrrepetible,
            bloquearCosto: res.data.configuracion?.bloquearCosto,
            noRecalcularPreciosAlEditarCosto:
              res.data.configuracion?.noRecalcularPreciosAlEditarCosto,
            priorizarReglasTipoCliente:
              res.data.configuracion?.priorizarReglasTipoCliente,
          });
        } else {
          message.error("Error no se encontro configuracion de esta empresa");
        }
      });
    this.setState({ loading: false })
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  /**
   * Da de baja una lista de precios.
   *
   * Una lista ya guardada NO se borra del arreglo: se marca con estado 0 y se
   * deja de renderizar. Quitarla de verdad recorreria el arreglo y Mongoose le
   * generaria un _id nuevo a las demas, dejando huerfanos todos los
   * Insumo.precios[].precioId, Cliente.precioContadoId, Caja.precioId, etc.
   * Un renglon recien agregado (sin _id) si se puede quitar en duro.
   */
  quitarLista(name, remove) {
    const precios = this.formRef.current.getFieldValue("precios") || [];
    const lista = precios[name];

    if (!lista || !lista._id) {
      remove(name);
      return;
    }

    const nuevosPrecios = [...precios];
    nuevosPrecios[name] = { ...lista, estado: 0 };
    this.formRef.current.setFieldsValue({ precios: nuevosPrecios });
    message.info(
      `"${lista.nombre || "La lista"}" se dio de baja. Guarda la configuracion para aplicarlo.`
    );
  }
  render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          name="insumosConfiguracion"
          layout
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          ref={this.formRef}
        >

          <Row gutter={[16, 16]}>
            {/* VALUACIÓN DE INVENTARIOS */}
            <DynamicCardForm title="Valuación de Inventarios" span={12} lg={12}
              style={{
                maxWidth: '98%',
                margin: '0 auto 12px auto',
              }}>
              <FormItem
                name="valuacionInventarios"
                label="Valuación Default"
                tooltip="Método default para la valuación de inventarios, este se puede cambiar en cada insumo"
                required
                margin
                labelCol={{ span: 7 }}
                wrapperCol={{ span: 14 }}
              >
                <SelectItem placeholder="Seleccionar lista de precios">
                  <Option value={1}>PEPS (Primeras Entradas, Primeras Salidas)</Option>
                  <Option value={2}>Costo Promedio Ponderado</Option>
                  <Option value={3}>Costo Específico</Option>
                </SelectItem>
              </FormItem>
            </DynamicCardForm>


            <DynamicCardForm
              title="Insumos"
              span={12}
              style={{
                maxWidth: '98%',
                margin: '0 auto 12px auto',
              }}
            >
              <Row gutter={[24, 0]}>
                <Col span={12}>
                  <FormItem
                    label="No vender abajo del costo"
                    name="noVenderAbajoCosto"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                    tooltip="No se podran generar ventas si el precio es menor al costo del insumo"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Vender sin inventario"
                    name="venderSinInventario"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                    tooltip="Se podra vender con inventario mas sin embargo no se podran entregar insumos hasta no tener el inventario"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Calcular Precios Automáticamente"
                    name="calcularPreciosAutomaticamente"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                    tooltip="Se calcularan por porcentaje del insumo cuando el costo cambie"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      const calcularPreciosAutomaticamente = getFieldValue("calcularPreciosAutomaticamente");
                      if (calcularPreciosAutomaticamente)
                        return (
                          <FormItem
                            label="No bajar precios"
                            name="noBajarPreciosAutomaticamente"
                            margin
                            initialValue={false}
                            labelCol={{ span: 14 }}
                            wrapperCol={{ span: 10 }}
                            valuePropName="checked"
                            tooltip="Al activarse los precios no se modificaran hacia abajo automaticamente unicamente hacia arriba"
                          >
                            <SwitchItem />
                          </FormItem>
                        );
                    }}
                  </FormItem>
                  <FormItem
                    label="Bloquear Costo"
                    name="bloquearCosto"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                    tooltip="Al activarse, el costo y los precios de los insumos no se modificaran automaticamente al recibir compras, unicamente se registrara el movimiento en el historial del insumo"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="No recalcular precios al editar el costo"
                    name="noRecalcularPreciosAlEditarCosto"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                    tooltip="Al activarse, cambiar el costo en Editar Insumo, Insumo Compuesto o Servicio ya no modifica los precios: se conservan y solo se ajusta el % Real al nuevo costo. No afecta las compras."
                  >
                    <SwitchItem />
                  </FormItem>
                </Col>
                <Col span={12}>
                  <FormItem
                    label="Control Marbetes"
                    name="marbetes"
                    tooltip="Con esta opción se podra llevar un control de marbetes y numeraciones de los mismos"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                  >
                    <SwitchItem disabled />
                  </FormItem>
                  <FormItem
                    label="Calcular Precios Sobre"
                    name="calcularPreciosSobre"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                  >
                    <SwitchItem unCheckedChildren="Venta" checkedChildren="Costo" />
                  </FormItem>
                  <FormItem
                    label="Código de barras obligatorio"
                    name="codBarObligatorio"
                    tooltip="Con esta opción se hara obligatorio poner un código de barras al crear un insumo desde Insumos o desde Insumo de cambio en una cotización."
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Clave irrepetible"
                    name="claveIrrepetible"
                    tooltip="Con esta opción se hara irrepetible la clave del insumo"
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                  >
                    <SwitchItem />
                  </FormItem>
                  <FormItem
                    label="Priorizar reglas del tipo de cliente"
                    name="priorizarReglasTipoCliente"
                    tooltip="Normalmente gana la regla mas especifica: la del cliente. Al activarse, las reglas de precio del tipo de cliente pisan a las del cliente."
                    margin
                    initialValue={false}
                    labelCol={{ span: 14 }}
                    wrapperCol={{ span: 10 }}
                    valuePropName="checked"
                  >
                    <SwitchItem />
                  </FormItem>
                </Col>
              </Row>
            </DynamicCardForm>
            {/* PRECIOS */}
            <DynamicCardForm title="Precios" span={12} lg={12}
              style={{
                maxWidth: '98%',
                margin: '0 auto 12px auto',
              }}>
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => (
                  <FormInicial.List name="precios">
                    {(fields, { add, remove }) => {
                      const listas = getFieldValue("precios") || [];
                      const activos = fields.filter(({ name }) => listaActiva(listas[name]));

                      return (
                        <>
                          <Collapse
                            accordion
                            // forceRender mantiene montados los FormItem de los paneles
                            // cerrados: sin el, un renglon nuevo que nunca se expande se
                            // enviaria vacio y sin pasar por las validaciones.
                            style={{ background: "transparent" }}
                          >
                            {activos.map(({ key, name, fieldKey, ...restField }) => {
                              const lista = listas[name] || {};
                              return (
                                <Collapse.Panel
                                  key={key}
                                  forceRender
                                  header={
                                    <span>
                                      {lista.nombre || "Lista sin nombre"}{" "}
                                      <Tag color="cyan">
                                        {(lista.porcentaje ?? 0) + "%"}
                                      </Tag>
                                      {Number(lista.calcularAutomaticamente) === 2 ? (
                                        <Tag>Sin calculo automatico</Tag>
                                      ) : null}
                                    </span>
                                  }
                                  // extra={
                                  //   <ButtonItem
                                  //     rojo2
                                  //     lessTime
                                  //     icon={<DeleteOutlined />}
                                  //     onClick={(e) => {
                                  //       e.stopPropagation();
                                  //       this.quitarLista(name, remove);
                                  //     }}
                                  //   />
                                  // }
                                >
                                  <Row gutter={[16, 0]}>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Nombre"
                                        name={[name, "nombre"]}
                                        fieldKey={[fieldKey, "nombre"]}
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                        required
                                        margin
                                      >
                                        <InputItem placeholder="Ej. Precio Medio" />
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Porcentaje"
                                        name={[name, "porcentaje"]}
                                        fieldKey={[fieldKey, "porcentaje"]}
                                        required
                                        margin
                                        tooltip="Margen sugerido para insumos nuevos de esta lista"
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem placeholder="Ej. 20%" porcentaje />
                                      </FormItem>
                                    </Col>

                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Margen minimo"
                                        name={[name, "margenMinimo"]}
                                        fieldKey={[fieldKey, "margenMinimo"]}
                                        margin
                                        tooltip="El calculo automatico nunca deja el margen por debajo de esto, y al vender se pide autorizacion si la linea lo rompe. Vacio = sin limite."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem placeholder="Sin limite" porcentaje />
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Margen maximo"
                                        name={[name, "margenMaximo"]}
                                        fieldKey={[fieldKey, "margenMaximo"]}
                                        margin
                                        tooltip="Tope superior del margen. Vacio = sin limite."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem placeholder="Sin limite" porcentaje />
                                      </FormItem>
                                    </Col>

                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Descuento minimo"
                                        name={[name, "descuentoMinimo"]}
                                        fieldKey={[fieldKey, "descuentoMinimo"]}
                                        margin
                                        tooltip="Descuento minimo obligado en la linea de venta. Vacio = sin minimo."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem placeholder="Sin minimo" porcentaje />
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Descuento maximo"
                                        name={[name, "descuentoMaximo"]}
                                        fieldKey={[fieldKey, "descuentoMaximo"]}
                                        margin
                                        tooltip="Tope de descuento en la linea de venta. No precarga el descuento, solo lo limita. Vacio = sin tope."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem placeholder="Sin tope" porcentaje />
                                      </FormItem>
                                    </Col>

                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Calculo automatico"
                                        name={[name, "calcularAutomaticamente"]}
                                        fieldKey={[fieldKey, "calcularAutomaticamente"]}
                                        margin
                                        tooltip="Recalcular el precio de esta lista cuando cambie el costo. Heredar toma la bandera general de la empresa. Una marca puede apagarlo aunque aqui diga que si."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <SelectItem placeholder="Heredar de la empresa">
                                          {OPCIONES_TRIESTADO.map((o) => (
                                            <Option value={o.valor} key={o.valor}>
                                              {o.etiqueta}
                                            </Option>
                                          ))}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Recalcular con"
                                        name={[name, "baseRecalculo"]}
                                        fieldKey={[fieldKey, "baseRecalculo"]}
                                        margin
                                        tooltip="Con que margen se recalcula el precio al cambiar el costo. Margen actual conserva el que el precio implica hoy; Margen fijo usa el porcentaje fijado en cada insumo; Margen de la lista usa el porcentaje de arriba, ya afinado por las reglas. Si la fuente elegida esta vacia en un insumo, se usa su margen actual."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <SelectItem placeholder="Margen actual del insumo">
                                          {OPCIONES_BASE_RECALCULO.map((o) => (
                                            <Option value={o.valor} key={o.valor}>
                                              {o.etiqueta}
                                            </Option>
                                          ))}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="No bajar precios"
                                        name={[name, "noBajarPrecios"]}
                                        fieldKey={[fieldKey, "noBajarPrecios"]}
                                        margin
                                        tooltip="Al recalcular, el precio solo puede subir. Heredar toma la bandera general de la empresa."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <SelectItem placeholder="Heredar de la empresa">
                                          {OPCIONES_TRIESTADO.map((o) => (
                                            <Option value={o.valor} key={o.valor}>
                                              {o.etiqueta}
                                            </Option>
                                          ))}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>

                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Redondeo"
                                        name={[name, "redondeo"]}
                                        fieldKey={[fieldKey, "redondeo"]}
                                        margin
                                        tooltip="Redondeo comercial al final del calculo automatico. Siempre redondea hacia arriba para no romper el margen."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <SelectItem placeholder="Ninguno">
                                          {OPCIONES_REDONDEO.map((o) => (
                                            <Option value={o.valor} key={o.valor}>
                                              {o.etiqueta}
                                            </Option>
                                          ))}
                                        </SelectItem>
                                      </FormItem>
                                    </Col>
                                    <Col span={12}>
                                      <FormItem
                                        {...restField}
                                        label="Factor precio piso"
                                        name={[name, "factorPrecioPiso"]}
                                        fieldKey={[fieldKey, "factorPrecioPiso"]}
                                        margin
                                        tooltip="El precio nunca queda por debajo de costo x este factor. Ej. 1.05 = al menos 5% arriba del costo. Vacio = sin piso."
                                        labelCol={{ span: 14 }}
                                        wrapperCol={{ span: 10 }}
                                      >
                                        <InputNumberItem
                                          placeholder="Ej. 1.05"
                                          min={0}
                                          step={0.05}
                                        />
                                      </FormItem>
                                    </Col>
                                  </Row>
                                </Collapse.Panel>
                              );
                            })}
                          </Collapse>

                          <div style={{ textAlign: "center", marginTop: 10 }}>
                            <ButtonItem
                              cyan
                              type="dashed"
                              onClick={() => {
                                if (activos.length < 10) {
                                  add();
                                } else {
                                  message.warning("No se pueden agregar mas de 10 precios");
                                }
                              }}
                              icon={<PlusOutlined />}
                            >
                              Agregar Precio
                            </ButtonItem>
                          </div>
                        </>
                      );
                    }}
                  </FormInicial.List>
                )}
              </FormItem>
            </DynamicCardForm>

                        {/* ATAJOS DE LA CALCULADORA DE PRECIOS */}
            {/* Los pinta la calculadora del modal Ver insumo (clic derecho en la
                columna PU) y la del Cotizador por Insumo. Sin atajos capturados
                se usan los de por defecto, no se queda sin botones. */}
            <DynamicCardForm title="Atajos de la calculadora de precios" span={12} lg={12}
              style={{
                maxWidth: '98%',
                margin: '0 auto 12px auto',
              }}>
              <FormInitial.List name="atajosPorcentaje">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ name }, arrayKey) => (
                      <Row key={arrayKey}>
                        <Col span={22}>
                          <FormItem
                            name={[name, "porcentaje"]}
                            fieldKey={[arrayKey, "porcentaje"]}
                            required
                            margin
                            noStyle
                          >
                            <InputNumberItem
                              porcentaje
                              min={-100}
                              max={1000}
                              step={0.5}
                              placeholder="Ej. 20"
                              style={{ width: "100%" }}
                            />
                          </FormItem>
                        </Col>
                        <Col flex="28px">
                          <div style={{ textAlign: 'center' }}>
                            <ButtonItem
                              rojo2
                              icon={<DeleteOutlined />}
                              onClick={() => remove(name)}
                              lessTime
                            />
                          </div>
                        </Col>
                      </Row>
                    ))}
                    <div style={{ textAlign: "center", marginTop: 10 }}>
                      <ButtonItem
                        cyan
                        type="primary"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                      >
                        Agregar
                      </ButtonItem>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </DynamicCardForm>


          </Row>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 8px', borderTop: '1px solid #f0f0f0', flexShrink: 0 }}>
            {/* Los dos reportes viven aqui y no en Listas de Precios: describen
                esta configuracion, y aqui es donde se acaba de capturar. */}
            <div style={{ display: 'flex', gap: 8 }}>
              <ButtonItem
                morado
                type="primary"
                icon={<FilePdfOutlined />}
                onClick={() => this.setState({ modalPdf: true })}
              >
                Configuracion PDF
              </ButtonItem>
              <ButtonItem
                siena
                type="primary"
                icon={<ExperimentOutlined />}
                loading={this.state.generandoSimulacion}
                onClick={() => this.descargarPdfSimulacion()}
              >
                Simulacion PDF
              </ButtonItem>
            </div>
            <ButtonItem
              cyan
              type="primary"
              htmlType="submit"
              style={{
                minWidth: 120,
                height: 30,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Guardar Configuración
            </ButtonItem>
          </div>

        </Form>

        <ModalItem
          title="Configuracion de Listas de Precios"
          visible={this.state.modalPdf}
          onCancel={() => this.setState({ modalPdf: false })}
          onOk={() => this.descargarPdfConfiguracion()}
          okText="Descargar PDF"
          confirmLoading={this.state.generandoPdf}
          width={520}
          footer
        >
          <p>
            El PDF incluye las banderas globales, todas las listas con sus rangos y reglas
            de calculo, las reglas base y por tipo de cliente, las escalas por cantidad y
            las marcas sin calculo automatico.
          </p>
          <Checkbox
            checked={this.state.incluirReglasPorCliente}
            onChange={(e) => this.setState({ incluirReglasPorCliente: e.target.checked })}
          >
            Incluir el detalle de reglas por cliente
          </Checkbox>
        </ModalItem>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(InsumosConfiguracion);
